"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthType = void 0;
var AuthType;
(function (AuthType) {
    AuthType["ClinicPetParent"] = "clinic_pet_parent_token";
    AuthType["InformPartnerUser"] = "inform_partner_user";
    AuthType["TerminalApp"] = "terminal_app";
})(AuthType = exports.AuthType || (exports.AuthType = {}));
//# sourceMappingURL=AuthType.js.map